import * as React from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { CardActionArea, useTheme } from "@mui/material";
import { FilmScreening } from "../../types/dataTypes.ts";
import { recordExternalScreeningClick } from "../../helpers/onCallFunctions.ts";

interface IndividualScreeningInfoParams extends FilmScreening {
  filmTitle: string;
}

export const IndividualScreeningInfo: React.FC<
  IndividualScreeningInfoParams
> = ({ venue_name, link, time, filmTitle }) => {
  const theme = useTheme();

  const date = new Date(time);
  const formattedTime = `${date.getHours()}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      recordExternalScreeningClick(filmTitle, venue_name, time);
    }
  };

  const anchorLabel = `Book tickets for ${filmTitle} at ${venue_name} – ${date}`;

  return (
    <Card variant="outlined" sx={{ width: "100%", height: "100%" }}>
      <CardActionArea
        component="a"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        aria-label={anchorLabel}
        title={anchorLabel}
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          "&:hover .venue-name": { color: theme.palette.text.primary },
        }}
      >
        <Typography
          variant="subtitle1"
          component="time"
          dateTime={date.toISOString()}
          sx={{ fontSize: "medium", fontWeight: 700 }}
        >
          {formattedTime}
        </Typography>

        <Typography
          className="venue-name"
          variant="body2"
          color="text.secondary"
          sx={{
            fontSize: "small",
            textAlign: "center",
            px: 1,
            transition: "color .3s",
          }}
        >
          {venue_name}
        </Typography>

        <Typography
          variant="button"
          component="span"
          sx={{ fontSize: "x-small", color: theme.palette.primary.main }}
        >
          BOOK HERE
        </Typography>
      </CardActionArea>
    </Card>
  );
};
